// extracted by mini-css-extract-plugin
export default {"container":"WidgetSettings_container__NlzFn","actions":"WidgetSettings_actions__K4qpk","actionButton":"WidgetSettings_actionButton__78IyX"};